import { FC, ReactElement, useEffect, useState } from "react"

import styles from "./XContent.module.scss"
import {CloseOutlined} from "@ant-design/icons"

export type XContentProps = {
  children?: any
  toggled?: boolean
}

export type XContentExtensions = {
  Transition: typeof Transition
  Modal: typeof Modal
}

export const XContent: FC<XContentProps> & XContentExtensions = ({
  children, toggled = false
}) => {
  return (
    <>
      <div className={styles.adminx_content + (toggled ? " " + styles.toggled : "")}>
        {children}
      </div>
    </>
  )
}

type TransitionProps = {
  children?: any
  visible?: boolean
}

const Transition: FC<TransitionProps> = ({
  children, visible = true
}) => {
  return (
    <>
      <div className={styles.adminx_main} style={{opacity: visible ? "1" : "0"}}>
        {children}
      </div>
    </>
  )
}

export type XContentModalProps = {
  children?: any
  visible: boolean
  closable?: boolean
  onClose?: () => void
}

export type ModalExtensions = {
  Title: typeof Title
  Subtitle: typeof Subtitle
  Close: typeof Close
  Body: typeof Body
}

export const Modal: FC<XContentModalProps> & ModalExtensions = ({
  children, visible, onClose, closable = true
}) => {

  const [previs, setPrevis] = useState(false)
  const [previs2, setPrevis2] = useState(false)

  const onKeydown = ({ key }: KeyboardEvent) => {
    switch (key) {
      case 'Escape':
        if (closable) {
          onClose!()
        }
        break
    }
  }

  const open = () => {
    setPrevis(true)

    document.getElementsByTagName("html")[0].style.overflowY = "hidden"
    document.addEventListener('keydown', onKeydown)

    setTimeout(() => {
      setPrevis2(true)
    }, 10)
  }

  const close = () => {
    setPrevis2(false)

    setTimeout(() => {
      document.getElementsByTagName("html")[0].style.overflowY = "scroll"
      document.removeEventListener('keydown', onKeydown)
      
      setPrevis(false)
    }, 300)
  }

  useEffect(() => {
    if (visible) {
      open()
    } else {
      close()
    }
  }, [visible])

  if (!previs)
    return null

  return (
    <>
      <div className={styles.xcontent_modal} style={{
        bottom: previs2 ? "0px" : "-2vh",
        opacity: previs2 ? "1" : "0"
      }}>
        <div className={styles.xcontent_modal__card}>
          {children}
        </div>
      </div>
    </>
  )
}

type TitleProps = {
  text: string | ReactElement
}

export const Title: FC<TitleProps> = ({
  text
}) => {
  return (
    <>
      <h2>{text}</h2>
    </>
  )
}

export const Subtitle: FC<TitleProps> = ({ text }) => {
  return (
    <>
      <h5>{text}</h5>
    </>
  )
}

type CloseProps = {
  onClick: () => void
}

export const Close: FC<CloseProps> = ({ 
  onClick
}) => {
  return (
    <>
      <div className={styles.xcontent_modal__close} onClick={() => onClick()}><CloseOutlined /></div>
    </>
  )
}

type BodyProps = {
  children?: any
}

export const Body: FC<BodyProps> = ({ children }) => {
  return (
    <>
      <div className={styles.xcontent_modal__body}>
        {children}
      </div>
    </>
  )
}

XContent.Transition = Transition
XContent.Modal = Modal

Modal.Title = Title
Modal.Subtitle = Subtitle
Modal.Close = Close
Modal.Body = Body